import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-27ca27d0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "middle payment" }
const _hoisted_2 = { class: "esim-error-payment" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "esim-error-payment__title" }, " Oops! We’re Experiencing Technical Issues ", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "esim-error-payment__description" }, " We’re currently having a technical problem with our payment method. Unfortunately, we can't process your payment at this moment. Our team is working hard to resolve the issue as quickly as possible. Please try again later. ", -1))

import WarningIcon from "@/components/icons/WarningIcon.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'PaymentDisabledView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(WarningIcon, { class: "esim-error-payment__icon" }),
      _hoisted_3,
      _hoisted_4,
      _createVNode(_component_router_link, {
        to: "/support",
        class: "btn btn-b btn-max btn-danger esim-error-payment__button"
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Write support ")
        ]),
        _: 1
      })
    ])
  ]))
}
}

})